import React from "react";
// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col,
	Table,
	UncontrolledTooltip,
	Input,
	FormGroup,
	Label,
	Alert,
	Collapse
} from "reactstrap";
import Async from 'react-select/async';
import moment from "moment";
import Datetime from "react-datetime";
import { isEqual } from 'lodash';

// Requests
import { getPaymentsRequest, deletePaymentRequest, markPaymentsAsPaid } from '../../api/payment';
import { getClientsRequest, getClientRequest } from "../../api/client";
import { uploadPaymentDocumentRequest } from "api/image";
// Components
import PaginationComponent from "../../components/Custom/Pagination";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import MarkAsPaidModal from "../../components/Payment/MarkAsPaidModal";
// Helpers
import { calcStartEndPage } from '../../helpers/pagination';
import { formatPrice } from "../../helpers/pricing";
import { formatPaymentStatus } from "../../helpers/status";
import { formatPaymentType, formatPaymentSubtype } from '../../helpers/payment';
import { hasPermission } from "helpers/auth";
// Context
import ProjectContext from "contexts/ProjectContext";
// Constants
import { paymentTypes, paymentSubtypes, paymentStatuses } from "../../constants";
// Assets
import { ReactComponent as IEye } from '../../assets/icons/eye.svg'
import { ReactComponent as ISlashedEye } from '../../assets/icons/slashedEye.svg'
import { ReactComponent as IClear } from '../../assets/icons/clear.svg'

class Payments extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			payments: null,
			total: 0,
			pages: 0,
			current_page: 0,
			start_page: 0,
			end_page: 9,
			first_page: 0,
			last_page: 0,
			deletePaymentId: '',
			start_date: '',
			end_date: '',
			selectedPayments: {},
			paymentBulkMessage: null,
			paymentBulkSuccess: null,
			filters: { limit: 25, page: 0, direction: 'inbound', search: '' },
			filtersClients: {},
			selectedClient: null,
			isCollapseOpen: true,
			loading: true,
			markAsPaidLoading: false,
			markAsPaidError: false
		}
		this.timeout = null;
	}
	static contextType = ProjectContext;

	componentDidMount() {
		this.previousContext = this.context;
		const { selectedProject } = this.context

		const paymentFilters = JSON.parse(localStorage.getItem('paymentFilters')) || this.state.filters;
		if(paymentFilters.client) {
			getClientRequest(paymentFilters.client).then(client => {
				this.setState({
					selectedClient: { label: `${client.first_name} ${client.last_name}`, value: client._id, data: client }
				});
			})
		}
		this.setState({
			filters: {...paymentFilters, page: paymentFilters.page || 0},
			start_date: (paymentFilters.start_date && moment(paymentFilters.start_date)) || '',
			end_date: (paymentFilters.end_date && moment(paymentFilters.end_date)) || '',
			current_page: paymentFilters.page || 0
		}, () => {
			if (selectedProject) this.getPayments()
		});
	}
	
	async componentDidUpdate(prevProps, prevState) {
		if(this.previousContext.selectedProject !== this.context.selectedProject) {
			this.previousContext.selectedProject = this.context.selectedProject
			await this.getPayments()
		}

		if(!isEqual(prevState.filters, this.state.filters)) {
			this.setState({
				current_page: 0
			});
			localStorage.setItem('paymentFilters', JSON.stringify({...this.state.filters, page: 0}));
		}

		if(this.state.current_page !== prevState.current_page) {
			const paymentFilters = JSON.parse(localStorage.getItem('paymentFilters'));
			localStorage.setItem('paymentFilters', JSON.stringify({ ...paymentFilters, page: this.state.current_page }));
		}

	}

	getPayments = async () => {
		this.setState({loading: true})
		const { filters } = this.state;
		const { selectedProject } = this.context

		filters.project = selectedProject
		
		const paymentsObj = await getPaymentsRequest(filters);
		const payments = paymentsObj.payments;
		
		const total = paymentsObj.total;
		const pages = Math.ceil(total / filters.limit);
		const last_page = pages - 1;
		const { start_page, end_page } = calcStartEndPage(0, pages);

		this.setState({
			payments,
			total,
			pages,
			start_page,
			last_page,
			end_page,
			loading: false
		})
	}

	goTo = path => this.props.history.push(path);

	goToNewTab = (path) => {
		const url = `${process.env.REACT_APP_BASE_URL}${path}`
		window.open(url, '_blank');
	}

	goToPage = async (page) => {
		const { pages, filters } = this.state;
		const { start_page, end_page } = calcStartEndPage(page, pages);

		const paymentsObj = await getPaymentsRequest({...filters, page});
		const payments = paymentsObj.payments;

		this.setState({
			payments,
			start_page: start_page,
			current_page: page,
			end_page: end_page
		});
	};

	loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
		const { selectedProject } = this.context;
	
		filtersClients.project = selectedProject;

		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})
		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

	onChangeSearch = (event) => {
		const search = event.target.value;
		const { filters } = this.state; 
		this.setState({
			filters: {...filters , search},
			page: 0
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getPayments();
		}, 300);
	}
	
	onChangeType = (event) => {
		const type = event.target.value;
		const { filters } = this.state;
		this.setState({
			filters: {...filters, type}
		}, this.getPayments);
	}

	onChangeSubtype = (event) => {
		const subtype = event.target.value;
		const { filters } = this.state;
		
		this.setState({
			filters: {...filters, subtype}
		}, this.getPayments);
	}

	onChangeStatus = (event) => {
		const status = event.target.value
		const { filters } = this.state;

		this.setState({
			filters: {...filters, status}
		}, this.getPayments);
	}

	onSelectChange = (key) => (object) => {
		const { filters } = this.state; 

		if(!object) {
            this.setState({
                filters: {...filters, [key]: ""},
				selectedClient: null
            }, () => {
                this.getPayments();
            })
            return;
        }

		this.setState({
			filters: {...filters, [key]: object.value},
			selectedClient: object
		}, () => {
			this.getPayments();
		})
	}

	onChangeDateFilter = (key) => (date) => {
		if(key === 'end_date') {
			date = date.endOf('day');
		}
		this.setState({
			[key]: date
		}, () => {
			const { filters, start_date, end_date } = this.state;

			if(start_date && end_date) {
				this.setState({
					filters: {
						...filters,
						start_date: start_date && start_date.toISOString(),
						end_date: end_date && end_date.toISOString(),

					}
				},this.getPayments);
			}
		});
	}
	
	isValidStartDate = (current) => {
		// return current < moment();
		return true;
	}

	isValidEndDate = (current) => {
		const { start_date } = this.state;

		if(start_date) {
			return current.diff(start_date, 'days') >= 0;
		}
	}

	openConfirmation = (paymentId) => () => {
		this.setState({
			deletePaymentId: paymentId
		});
		this.deleteConfirmationModal.toggle();
    }

	deletePayment = async () => {
		const { deletePaymentId } = this.state;
        await deletePaymentRequest(deletePaymentId);
        this.getPayments()
	}

	getSelectedPaymentIds = () => {
		const { selectedPayments = {} } = this.state;
		return Object.keys(selectedPayments).filter(key => selectedPayments[key]);
	}

	selectAll = (event) => {
		const { payments } = this.state;
	
		let selectedPayments = {};
	
		payments.forEach(product => {
		  selectedPayments[product._id] = event.target.checked;
		});
		this.setState({
		  selectedPayments
		});
	}

	setSelectedPayment = (productId) => (event) => {
		const { checked } = event.target;
		this.setState((prevState) => ({
		  selectedPayments: {
			...prevState.selectedPayments,
			[productId]: checked
		  }
		}));
	}

	openMarkAsPaidModal = () => {
		this.markAsPaidModal.toggle();
	}

	markBulkPaymentsAsPaid = async (settled_date, sales_invoice, acknowledgement_receipt, note, isPartialPayment, paymentValue) => {
		const { selectedPayments } = this.state;
		this.setState({
			markAsPaidLoading: true
		})

		try {
			let invoiceUrl = '';
			if(sales_invoice) {
				invoiceUrl = await uploadPaymentDocumentRequest(Object.keys(selectedPayments), sales_invoice);
			}
			let receiptUrl = '';
			if(acknowledgement_receipt) {
				receiptUrl = await uploadPaymentDocumentRequest(Object.keys(selectedPayments), acknowledgement_receipt);
			}

			const requestData = {
				paymentIds: Object.keys(selectedPayments), 
				settled_date,
				sales_invoice: invoiceUrl,
				acknowledgement_receipt: receiptUrl,
				note,
				isPartialPayment, 
				paymentValue
			}


			const response = await markPaymentsAsPaid(requestData);
			this.getPayments();
			this.markAsPaidModal.toggle();
			this.setState({
				selectedPayments: {},
				paymentBulkSuccess: true,
				paymentBulkMessage: response.message,
				markAsPaidLoading: false
			});	
		} catch(error) {
			console.log('error', error)
			this.setState({
				paymentBulkSuccess: false,
				paymentBulkMessage: 'There was an error while updating the payments',
				markAsPaidError: 'There was an error while updating the payments',
				markAsPaidLoading: false
			});
		} finally {
			window.scrollTo(0, 0)
			setTimeout(() => this.setState({
				paymentBulkSuccess: null,
				paymentBulkMessage: null,
			}), 5000);
		}
	}

	calculateTotalAmount = (payment) => {
		const {
			amount,
			loan_interest,
			extras
		} = payment;
		const entries = [amount, loan_interest, extras].filter(item => !!Number(item));
		const totalEntries = entries.length ? entries.reduce((item1, item2) => Number(item1)+Number(item2)) : 0;
		return totalEntries;
	}

	render() {

		const {
			payments,
			pages,
			current_page,
			start_page,
			end_page,
			selectedPayments,
			paymentBulkMessage,
			paymentBulkSuccess,
			filters,
			start_date,
			end_date,
			selectedClient,
			isCollapseOpen,
			loading,
			markAsPaidError,
			markAsPaidLoading
		} = this.state;

		const {
			search,
			type,
			subtype,
			status
		} = filters;

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<Row className='mb-3'>
										<Col>
											<CardTitle tag="h4">Payments</CardTitle>
										</Col>
										
									</Row>
									<Row>
										<Col className="d-flex justify-content-end">
											<Button id='show-hide' className="filters-btn" onClick={() => this.setState({ isCollapseOpen: !isCollapseOpen })}>
												{isCollapseOpen ? 
													<>
														<ISlashedEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Hide filters
														</UncontrolledTooltip>
													</>
												: 
													<>
														<IEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Show filters
														</UncontrolledTooltip>
													</>
												}
											</Button>
											<Button id="clean" className="filters-btn" onClick={() => this.setState({ filters: {limit: 25, status: '', type: '', subtype: '', search: ''}, selectedClient: null, start_date: '', end_date: '' }, this.getPayments)}>
												<IClear/>
												<UncontrolledTooltip
													delay={0}
													target='clean'
												>
													Clean filters
												</UncontrolledTooltip>
											</Button>
										</Col>
									</Row>
									<Collapse
										isOpen={isCollapseOpen}
									>
											{paymentBulkMessage &&
												<Row>
												<Col md={12}>
													<Alert color={paymentBulkSuccess ? 'success' : 'danger'} fade={false}>{paymentBulkMessage}</Alert>
												</Col>
												</Row>
											}
											<Row>
												<Col sm="6">
													<FormGroup>
														<Label>Start Date</Label>
														<Datetime
															inputProps={{
																className: "form-control",
																placeholder: "Start Date",
																name: "start_date"
															}}
															timeFormat={false}
															value={start_date}
															onChange={this.onChangeDateFilter('start_date')}
															isValidDate={this.isValidStartDate}
															closeOnSelect={true}
															dateFormat="DD/MM/YYYY"
														/>
													</FormGroup>
												</Col>
												<Col sm="6">
													<FormGroup>
														<Label>End Date</Label>
														<Datetime
															inputProps={{
																className: "form-control",
																placeholder: "End Date",
																name: "end_date"
															}}
															timeFormat={false}
															value={end_date}
															onChange={this.onChangeDateFilter('end_date')}
															isValidDate={this.isValidEndDate}
															closeOnSelect={true}
															dateFormat="DD/MM/YYYY"
														/>
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col>
													<FormGroup>
														<Label>Client</Label>
														<Async
															clearValue={""}
															value={selectedClient}
															name="client"
															options={[]}
															loadOptions={this.loadClients}
															className="basic-multi-select"
															classNamePrefix="select"
															onChange={this.onSelectChange('client')}
															placeholder="Client..."
															isClearable={true}
														/>
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col>	
													<FormGroup>
														<Label>Search</Label>
														<Input placeholder="Search..." value={search} type="text" onChange={this.onChangeSearch}></Input>
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col sm="6">
													<FormGroup>
														<Label>Type</Label>
														<Input 
															value={type} 
															type="select" 
															onChange={this.onChangeType}
															className={type ? "mt-2" : 'mt-2 select__placeholder'}
														>
															<option className="select__placeholder" value="">Select Type...</option>
															{
																paymentTypes.map(type => {
																	return <option key={type} value={type}>{formatPaymentType(type)}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
												<Col sm="6">
													<FormGroup>
														<Label>Subtype</Label>
														<Input 
															className={subtype ? "mt-2" : 'mt-2 select__placeholder'}
															value={subtype}
															type="select"
															onChange={this.onChangeSubtype}
															
														>
															<option value="">Select Subtype...</option>
															{
																paymentSubtypes.map(subtype => {
																	return <option key={subtype} value={subtype}>{formatPaymentSubtype(subtype)}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col>
													<FormGroup>
														<Label>Status</Label>
														<Input 
															className={status ? "mt-2" : 'mt-2 select__placeholder'} 
															value={status} 
															type="select" 
															onChange={this.onChangeStatus}
														>
															<option value="">Select Status...</option>
															{
																paymentStatuses.map(status => {
																	return <option key={status} value={status}>{formatPaymentStatus(status)}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
											</Row>
									</Collapse>
									<Row>
										<Col sm='12' className='d-flex justify-content-end mt-3'>											
											<Button disabled={this.getSelectedPaymentIds().length ? false : true} color="primary" onClick={this.openMarkAsPaidModal}>Mark selected as Paid</Button>
											{hasPermission('CreatePayment') ? <Button color="primary" className="add-btn" onClick={() => this.goTo('/payment/create')}><i className="tim-icons icon-simple-add" /> Payment</Button> : null}
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<Table responsive>
										<thead className="text-primary">
											<tr>
												{hasPermission('EditPayment') ? <th><input type="checkbox" onChange={this.selectAll} checked={this.getSelectedPaymentIds().length === (payments && payments.length)} /></th> : null}
												<th>Due date</th>
												<th>Client</th>
												<th>Type</th>
												<th>Value</th>
												<th>Interest & Extras</th>
												<th>Total</th>
												<th>Status</th>
												<th>Check</th>
												<th className="text-right">Actions</th>
											</tr>
										</thead>
										<tbody>
											{loading ? 
												<tr>
													<td colSpan={10}>Loading...</td>
												</tr>
											:
											payments && payments.length
												? payments.map((payment) => {

													let calculatedTotal;
													if (payment.total && payment.total !== 0) {
														calculatedTotal = payment.total;
													} else {
														calculatedTotal = this.calculateTotalAmount(payment)
													}
													return (
														<tr key={payment._id}>
															{hasPermission('EditPayment') && 
																<td>
																	<input type="checkbox" disabled={payment?.status === 'completed' && true} checked={!!selectedPayments[payment._id]} onChange={this.setSelectedPayment(payment._id)}></input>
																</td>
															}
                                                            <td>{moment(payment.due_date).format("MM/DD/YYYY")}</td>
															<td>{payment.client ? `${payment.client.first_name} ${payment.client.last_name}` : "N/A"}</td>
															<td>{payment.type ? formatPaymentType(payment.type) : "N/A"} {payment.subtype ? `(${formatPaymentSubtype(payment.subtype)})` : null}</td>
															<td>{payment.amount ? <>
																<span className={payment.is_inbound === true ? 'text-success' : payment.is_inbound === false ? 'text-danger' : ''}>{payment.is_inbound === true ? '+' : payment.is_inbound === false ? '-' : ''} {`$ ${formatPrice(payment.amount)}`}</span>
															</> : "N/A"}</td>
															<td>{(payment.loan_interest || payment.extras) ? <>
																<span className={payment.is_inbound === true ? 'text-success' : payment.is_inbound === false ? 'text-danger' : ''}>{payment.is_inbound === true ? '+' : payment.is_inbound === false ? '-' : ''} {`${formatPrice(payment.loan_interest + payment.extras)}`}</span>
															</> : "N/A"}</td>
															<td>{calculatedTotal ? <>
																<span className={payment.is_inbound === true ? 'text-success' : payment.is_inbound === false ? 'text-danger' : ''}>{payment.is_inbound === true ? '+' : payment.is_inbound === false ? '-' : ''} {`${formatPrice(calculatedTotal)}`}</span>
															</> : "N/A"}</td>
															<td>{payment.status ? formatPaymentStatus(payment.status) : "N/A"}</td>
															<td>{payment.check_number ? `${payment.check_number}${payment.bank_name ? ` : ${payment.bank_name}` : ''}` : "N/A"}</td>
															<td className="text-right">
																<Button
																	className="btn-link btn-icon"
																	color="success"
																	id={`tooltip-view-${payment._id}`}
																	size="sm"
																	onClick={() => this.goToNewTab(`/payment?id=${payment._id}`)}
																>
																	<i className="tim-icons icon-zoom-split" />
																</Button>
																<UncontrolledTooltip
																	delay={0}
																	target={`tooltip-view-${payment._id}`}
																>
																	View
                                                                </UncontrolledTooltip>
																{hasPermission('EditPayment') ? <> 
																	<Button
																		className="btn-link btn-icon"
																		color="info"
																		id={`tooltip-edit-${payment._id}`}
																		size="sm"
																		onClick={() => this.goToNewTab(`/payment/edit?id=${payment._id}`)}
																	>
																		<i className="tim-icons icon-pencil" />
																	</Button>
																	<UncontrolledTooltip
																		delay={0}
																		target={`tooltip-edit-${payment._id}`}
																	>
																		Edit
																	</UncontrolledTooltip>
																	<Button
																		className="btn-link btn-icon"
																		color="danger"
																		id={`tooltip-delete-${payment._id}`}
																		size="sm"
																		onClick={this.openConfirmation(payment._id)}
																	>
																		<i className="tim-icons icon-simple-remove" />
																	</Button>
																	<UncontrolledTooltip
																		delay={0}
																		target={`tooltip-delete-${payment._id}`}
																	>
																		Delete
																	</UncontrolledTooltip>
																</> : null}
															</td>
														</tr>
													)
												})
												: <tr>
													<td colSpan="10">There's no payment to show</td>
												</tr>
											}
										</tbody>
									</Table>
									{payments?.length > 0 &&
										<PaginationComponent
											pages={pages}
											current_page={current_page}
											start_page={start_page}
											end_page={end_page}
											goToPage={this.goToPage}
										/>
                    }
								</CardBody>
							</Card>
						</Col>
					</Row>
					<ConfirmationModal
						ref={el => this.deleteConfirmationModal = el}
						title="Delete Payment?"
						buttons={[
							{ title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
							{ title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deletePayment }
						]}
					>
						Are you sure you want to delete this payment?
					</ConfirmationModal>
					<MarkAsPaidModal
						onSave={this.markBulkPaymentsAsPaid}
						ref={(c) => this.markAsPaidModal = c}
						error={markAsPaidError}
						loading={markAsPaidLoading}
						selectedPayments={selectedPayments}
					/>
				</div>
			</>
		);
	}
}

export default Payments;
